// import { isValidNumber } from "libphonenumber-js";
// import { debugLogger } from "./LogDebug";

/**
 * Vérifie la validité d'un numéro de téléphone pour un pays donné.
 * @param {string} phoneNumber - Le numéro de téléphone saisi par l'utilisateur.
 * @param {Object} country - Les informations du pays (countryCode, format, name, etc.).
 * @returns {Object} - { isValid: true/false, phone: "+33612345678", error: "Message d'erreur" }
 */
export const validatePhoneNumber = (phoneNumber, country) => {
// phoneNumer":"+
// 679123456789012","country":{"countryCode":"FJ","format":"+................."},}

//  debugLogger.log({"validatePhoneNumber phoneNumer": phoneNumber, "country": country});

    if (!phoneNumber || !country) return { isValid: false, error: "Missing phone number or country data." };

    const countryCode = country?.countryCode?.toUpperCase();
    if (!countryCode) return { isValid: false, error: "Invalid country code." };

    // Supprimer les espaces et le "+"
    const cleanNumber = phoneNumber.replace(/[\s+()-.]/g, "");

    // Obtenir la longueur attendue du numéro pour ce pays
    const lengthFormat = String(country?.format?.replace(/[\s+()-]/g, "")).length;
    const lengthPhone = cleanNumber.length;
    /*
    debugLogger.log({"phoneNumber": phoneNumber, "cleanNumber": cleanNumber, 
            "country": country, 
            "lengthPhone": lengthPhone, 
            "lengthFormat": lengthFormat, 
            "ou": country.format.length});
/*
{"phoneNumber":
"+206636034346465","cleanNumber":
"206636034346465","country":{"countryCode":"EG","format":"+.. ... ... ... ... ..","name":"Egypt"},
"lengthPhone":15,"lengthFormat":16,"ou":22}
*/
    // if (lengthPhone !== lengthFormat) {
    // debugLogger.log("if (lengthPhone < lengthFormat - 2 )" + lengthPhone + " < " + (lengthFormat - 2) + " = " + (lengthPhone < lengthFormat - 2));
    if (lengthPhone < lengthFormat - 2) { // TODO Corriger ce bogue // marge d'erreur
        return { isValid: false, error: `Phone number +${cleanNumber} is incorrect length. Expected ${lengthFormat} digits. Format must be ${country.format} for ${country.name}` };
    }

    // Vérifier si le numéro est valide pour ce pays
    /*
    const isValid = isValidNumber(cleanNumber, countryCode, country.name);
    if (!isValid) {
        return { isValid: false, error: `Invalid phone number format for ${country.name}.` };
    }
        */

    return { isValid: true, phone: `+${cleanNumber}` }; // Retourne le numéro propre avec "+"
};

export default validatePhoneNumber;
